import React from 'react';
import BasicModal from './BasicModal';
import icon_rename from 'images/new_pop_ups/rename.svg';
import { useEffect, useRef } from 'react';

const RenameModal = (props) => {
    const handleFocus = (event) => event.target.select();
    let modalTypes = {
        renameAnalysis: {
            title: 'Rename Analysis',
            description: 'Please choose a new name for the analysis.'
        },
        renameFile: {
            title: 'Rename Dataset',
            description: 'Please choose a new name for the dataset.'
        },
        renameProject: {
            title: 'Rename Project',
            description: 'Please choose a new name for the project.'
        },
        renameColumn: {
            title: 'Rename Column',
            description: 'Please choose a new name for the column.'
        },
        renameTransformation: {
            title: 'Rename Transformation',
            description: 'Please choose a new name for the transformation.'
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            props.onAccept();
        }
    };

    return (
        <>
            <BasicModal
                autoFocus={false}
                title={modalTypes[props.modalType].title}
                visible={props.visible}
                icon={icon_rename}
                onAccept={props.onAccept}
                onCancel={props.onCancel}
                onAcceptTitle="OK"
            >
                <div>
                    <div>
                        <p
                            className="p-desctiption"
                            style={{ marginBottom: '100px' }}
                            dangerouslySetInnerHTML={{
                                __html: modalTypes[props.modalType].description
                            }}
                        ></p>
                    </div>
                    <div style={{ marginBottom: 214 }}>
                        <div
                            style={{
                                // border: '1px solid #E5E5E5',
                                height: '33px'
                            }}
                        >
                            <input
                                style={{
                                    padding: '5px',
                                    // color: '#828389',
                                    color: '#000',
                                    width: '100%'
                                }}
                                autoFocus={true}
                                onFocus={handleFocus}
                                onChange={props.handleNewRename}
                                value={props.currentName}
                                onKeyDown={(e) => {
                                    handleKeyDown(e);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </BasicModal>
        </>
    );
};

export default RenameModal;
